<template>
  <div class="qualification-review" v-loading="loading" :element-loading-text="loadingText">
    <div class="content" :class="{'more-high': !isCanVerify || isView}">
      <template v-if="loaded">
        <div class="top">
          <div class="blue-title">报名表信息</div>
          <div class="edit">
            <div>
              <span v-if="isEdit" @click="editOrSave">保存</span>
              <span v-else @click="editOrSave">编辑</span>
            </div>
            <div v-if="isEdit" class="reset">
              <span @click="reset">取消</span>
            </div>
          </div>
        </div>
        <div class="table">
          <div class="table-title">
            <div>陕西工商管理硕士学院</div>
            <div>{{ admissionYear }}年工商管理硕士（{{ basicInfo.studentType }}）研究生考生报名登记表</div>
          </div>
          <el-form ref="form" :model="enrollBasicInfo">
            <div class="form-up">
              <el-descriptions class="margin-top" :column="5" border :labelStyle="labelStyle" :contentStyle="contentStyle">
                <el-descriptions-item label="姓名*" :span="1">
                  <div class="descriptions-content name">
                    <span v-if="!isEdit || passCardVerify">{{ basicInfo.trueName }}</span>
                    <el-input v-else v-model="basicInfo.trueName"></el-input>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="性别*" :span="1.5">
                  <div class="descriptions-content gender">
                    <span v-if="!isEdit || passCardVerify">{{ codeToName(basicInfo.gender, genderList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.gender"
                               size="mini"
                               filterable>
                      <el-option v-for="gender in genderList"
                                 :key="gender.code"
                                 :label="gender.name"
                                 :value="gender.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="出生日期*" :span="1.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit || passCardVerify">{{ basicInfo.birthday.slice(0, 4) }} <span class="common">年</span> {{ basicInfo.birthday.slice(5, 7) }} <span class="common">月</span> {{ basicInfo.birthday.slice(8, 10) }} <span class="common">日</span></span>
                    <el-date-picker
                        v-else
                        v-model="basicInfo.birthday"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        format="yyyy 年 MM 月 dd 日"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="籍贯*" :span="2">
                  <div class="descriptions-content">
                  <span v-if="!isEdit">
                    <span>{{ basicInfo.originProvinceName + basicInfo.originCityName }}</span>
                  </span>
                    <el-cascader v-else
                                 v-model="basicInfo.origin" :options="provinceAndCityData" @change="changeOrigin">
                    </el-cascader>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="民族*" :span="2">
                  <div class="descriptions-content">
                    <span v-if="!isEdit || passCardVerify">{{ codeToName(basicInfo.folk, folkList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.folk"
                               size="mini"
                               filterable>
                      <el-option v-for="folk in folkList"
                                 :key="folk.code"
                                 :label="folk.name"
                                 :value="folk.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="所在地市*" :span="2">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.regionProvinceName + basicInfo.regionCityName }}</span>
                    <el-cascader v-else
                                 v-model="basicInfo.fromRegion" :options="provinceAndCityData" @change="changeRegion">
                    </el-cascader>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="政治面貌*" :span="2">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ codeToName(basicInfo.polity, polityList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.polity"
                               size="mini"
                               filterable>
                      <el-option v-for="polity in polityList"
                                 :key="polity.code"
                                 :label="polity.name"
                                 :value="polity.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="证件类型" labelClassName="higher">
                  <div class="descriptions-content">
                    <span v-if="true">{{ codeToName(basicInfo.cardType, cardTypeList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.cardType"
                               size="mini"
                               filterable>
                      <el-option v-for="cardType in cardTypeList"
                                 :key="cardType.code"
                                 :label="cardType.name"
                                 :value="cardType.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="证件号码" :span="1.5">
                  <div class="descriptions-content">{{ basicInfo.cardNo }}</div>
                </el-descriptions-item>
                <el-descriptions-item label="参加工作时间*" :span="1.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.joinWorkDate.slice(0, 4) }} <span class="common">年</span> {{ basicInfo.joinWorkDate.slice(5, 7) }} <span class="common">月</span></span>
                    <el-date-picker
                        v-else
                        v-model="basicInfo.joinWorkDate"
                        :clearable="false"
                        value-format="yyyy-MM"
                        format="yyyy 年 MM 月"
                        type="month"
                        placeholder="选择日期">
                    </el-date-picker>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="工作单位*" :span="2.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.workUnit }}</span>
                    <el-input v-else v-model="basicInfo.workUnit"></el-input>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="单位性质*" :span="1.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ codeToName(basicInfo.workUnitType, workUnitTypeList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.workUnitType"
                               size="mini"
                               filterable>
                      <el-option v-for="workUnitType in workUnitTypeList"
                                 :key="workUnitType.code"
                                 :label="workUnitType.name"
                                 :value="workUnitType.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="职级*" labelClassName="higher" :span="2">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ codeToName(basicInfo.jobLevel, jobLevelList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.jobLevel"
                               size="mini"
                               filterable>
                      <el-option v-for="jobLevel in jobLevelList"
                                 :key="jobLevel.code"
                                 :label="jobLevel.name"
                                 :value="jobLevel.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="所属行业*" :span="2">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ codeToName(basicInfo.industry, industryList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.industry"
                               size="mini"
                               filterable>
                      <el-option v-for="industry in industryList"
                                 :key="industry.code"
                                 :label="industry.name"
                                 :value="industry.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="empty" contentClassName="empty-content">
                  <div class="descriptions-content"></div>
                </el-descriptions-item>
                <el-descriptions-item label="职务*" labelClassName="higher" :span="2.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.jobDuty }}</span>
                    <el-input v-else v-model="basicInfo.jobDuty"></el-input>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="职称*" :span="2.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ codeToName(basicInfo.jobTitle, jobTitleList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.jobTitle"
                               size="mini"
                               filterable>
                      <el-option v-for="jobTitle in jobTitleList"
                                 :key="jobTitle.code"
                                 :label="jobTitle.name"
                                 :value="jobTitle.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="手机*" :span="2.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.mobilePhone }}</span>
                    <el-input v-else v-model="basicInfo.mobilePhone"></el-input>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="电子信箱*" :span="2.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.email }}</span>
                    <el-input v-else v-model="basicInfo.email"></el-input>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="紧急联系人*" :span="2.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.emergencyContactName }}</span>
                    <el-input v-else v-model="basicInfo.emergencyContactName"></el-input>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="紧急联系方式*" :span="2.5">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.emergencyContactPhone }}</span>
                    <el-input v-else v-model="basicInfo.emergencyContactPhone"></el-input>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="通信地址" :span="2">
                  <div class="descriptions-content">
                  <span v-if="!isEdit">
                    <span>{{ basicInfo.addressRegionName }}</span>
                  </span>
                    <el-cascader v-else
                                 v-model="basicInfo.addressRegionCodeArray"
                                 :options="provinceCityAreaData" @change="changeRegionArray">
                    </el-cascader>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="详细通信地址" :span="3">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ basicInfo.address }}</span>
                    <el-input v-else v-model="basicInfo.address"></el-input>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="最终学历*">
                  <div class="descriptions-content">
                    <span v-if="!isEdit">{{ codeToName(basicInfo.degree, degreeList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.degree"
                               size="mini"
                               filterable>
                      <el-option v-for="degree in degreeList"
                                 :key="degree.code"
                                 :label="degree.name"
                                 :value="degree.code"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="" labelClassName="none" contentClassName="none-content" :span="4">
                  <div class="descriptions-content">
                    <div class="graduation">
                     <span v-if="!isEdit" class="graduation-date">
                       <span class="year">{{ (basicInfo.graduateDate).slice(0, 4) }}</span><span class="grey">年</span>
                       <span class="month">{{ (basicInfo.graduateDate).slice(5, 7) }}</span><span class="grey">月毕业于</span>
                     </span>
                      <span v-else>
                        <el-date-picker
                            v-model="basicInfo.graduateDate"
                            :clearable="false"
                            value-format="yyyy-MM-dd"
                            format="yyyy年MM月"
                            type="month"
                            placeholder="选择日期">
                        </el-date-picker>
                       <span class="grey">毕业于</span>
                     </span>
                      <span class="school">
                       <span v-if="!isEdit">{{ basicInfo.graduateSchool }}</span>
                        <el-input v-else v-model="basicInfo.graduateSchool"></el-input>
                     </span>
                      <span class="grey">学校</span>
                      <span class="speciality">
                       <span v-if="!isEdit">{{ basicInfo.graduateMajor }}</span>
                       <el-input v-else v-model="basicInfo.graduateMajor"></el-input>
                     </span>
                      <span class="grey">专业</span>
                    </div>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item label="报考教学点*" :span="2.5">
                  <div class="descriptions-content text-left">
                    <span v-if="!isEdit || !isCanUpdateSite">{{ idToName(basicInfo.siteId, siteList) }}</span>
                    <el-select v-else
                               v-model="basicInfo.siteId"
                               size="mini"
                               filterable>
                      <el-option v-for="site in siteList"
                                 :key="site.id"
                                 :label="site.name"
                                 :value="site.id"/>
                    </el-select>
                  </div>
                </el-descriptions-item>
<!--                <el-descriptions-item label="意向上课城市*" :span="2.5">-->
<!--                  <div class="descriptions-content text-left">-->
<!--                    <span v-if="!isEdit">{{ codeToName(basicInfo.intendCity, intendCityList) }}</span>-->
<!--                    <el-select v-else-->
<!--                               v-model="basicInfo.intendCity"-->
<!--                               size="mini"-->
<!--                               filterable>-->
<!--                      <el-option v-for="site in intendCityList"-->
<!--                                 :key="site.code"-->
<!--                                 :label="site.name"-->
<!--                                 :value="site.code"/>-->
<!--                    </el-select>-->
<!--                  </div>-->
<!--                </el-descriptions-item>-->
              </el-descriptions>
              <div class="right-img" :class="{'edit': isEdit}">
                <img v-if="basicInfo.userPhotoPath" :src="basicInfo.userPhotoPath" alt="">
                <span v-else>2寸红底正面免冠照片</span>
              </div>
            </div>
            <div class="form-down">
              <div class="down-left">学习与工作经历</div>
              <div class="table">
                <el-table
                    :data="basicInfo.experienceList"
                    border
                    :cell-style="{borderColor:'#000'}"
                    :header-cell-style="{borderColor:'#000'}"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                  <el-table-column
                      v-if="isEdit"
                      type="selection"
                      width="40">
                  </el-table-column>
                  <el-table-column
                      prop="date"
                      label="开始日期"
                      width="150"
                      align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div v-if="!isEdit">{{ dateToChinese(scope.row.startDate) }}</div>
                        <div v-else class="job-and-work-data-adjust">
                          <el-date-picker
                              v-model="scope.row.startDate"
                              :clearable="false"
                              type="month"
                              format="yyyy年MM月"
                              value-format="yyyy-MM">
                          </el-date-picker>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="date"
                      label="结束日期"
                      width="208"
                      align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div v-if="!isEdit">{{ dateToChinese(scope.row.endDate) }}</div>
                        <div v-else class="job-and-work-data-adjust">
                          <el-date-picker
                              v-model="scope.row.endDate"
                              :clearable="false"
                              :disabled="scope.row.isLockEndDate"
                              type="month"
                              format="yyyy年MM月"
                              value-format="yyyy-MM">
                          </el-date-picker>
                          <el-checkbox v-model="scope.row.isLockEndDate" @change="changeLockEndTime(scope.row)">至今</el-checkbox>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="workUnit"
                      label="学习经历或工作单位"
                      min-width="300"
                      align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div v-if="!isEdit">{{ scope.row.workUnit }}</div>
                        <div v-else>
                          <el-input v-model="scope.row.workUnit"></el-input>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="workDuty"
                      label="担任职务" width="195"
                      align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div v-if="!isEdit">{{ scope.row.workDuty }}</div>
                        <div v-else>
                          <el-input v-model="scope.row.workDuty"></el-input>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="add-btn" v-if="isEdit">
              <el-button @click="addExperience">添加一行</el-button>
              <el-button type="danger" @click="deleteExperience">删除选中行</el-button>
            </div>
            <div class="form-down" v-if="basicInfo.studentType === 'EMBA'">
              <div class="down-left">荣誉和论著</div>
              <div class="table">
                <el-table
                  :data="basicInfo.honorList"
                  border
                  :cell-style="{borderColor:'#000'}"
                  :header-cell-style="{borderColor:'#000'}"
                  style="width: 100%"
                  @selection-change="handleHonorSelectChange">
                  <el-table-column
                    v-if="isEdit"
                    type="selection"
                    width="40">
                  </el-table-column>
                  <el-table-column
                    prop="honorName"
                    label="名称"
                    min-width="200"
                    align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div v-if="!isEdit">{{scope.row.honorName}}</div>
                        <el-input v-model="scope.row.honorName" v-else></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="honorUnitName"
                    label="颁奖/认证机构"
                    width="200"
                    align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div v-if="!isEdit">{{scope.row.honorUnitName}}</div>
                        <el-input v-model="scope.row.honorUnitName" v-else></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="honorDate"
                    label="获得/发表时间"
                    width="200"
                    align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div v-if="!isEdit">{{ scope.row.honorDate }}</div>
                        <el-date-picker
                          v-model="scope.row.honorDate"
                          :clearable="false"
                          format="yyyy年MM月dd日"
                          value-format="yyyy-MM-dd"
                          v-else
                        >
                        </el-date-picker>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="特殊说明"
                    width="200"
                    align="center">
                    <template slot-scope="scope">
                      <div class="table-center">
                        <div v-if="!isEdit">{{scope.row.remark}}</div>
                        <el-input v-model="scope.row.remark" v-else></el-input>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="add-btn" v-if="isEdit && basicInfo.studentType === 'EMBA'">
              <el-button @click="addHonor">添加一行</el-button>
              <el-button type="danger" @click="deleteHonor">删除选中行</el-button>
            </div>
          </el-form>
        </div>
        <div class="apply">
          <div class="blue-title apply-title">
            <el-tooltip content="免笔试申请单独审核" placement="top-start"><span>免入学笔试申请</span></el-tooltip>
            <div v-if="basicInfo.exemptWriteType !== '0'">
              <el-tag type="success" v-if="basicInfo.exemptWriteFirstStatus === '1'">初审通过</el-tag>
              <el-tag type="danger" v-else-if="basicInfo.exemptWriteFirstStatus == '0'">初审不通过
                <el-tooltip :content="basicInfo.exemptNoPassReason" placement="right"><i class="el-icon-info"></i></el-tooltip>
              </el-tag>
              <el-tag type="info" v-else>初审待审核</el-tag>
            </div>
            <div v-if="basicInfo.exemptWriteType !== '0' && basicInfo.exemptWriteFirstStatus === '1'">
              <el-tag type="success" v-if="basicInfo.exemptWriteLastStatus === '1'">终审通过</el-tag>
              <el-tag type="danger" v-else-if="basicInfo.exemptWriteLastStatus == '0'">终审不通过
                <el-tooltip :content="basicInfo.exemptNoPassReason" placement="right"><i class="el-icon-info"></i></el-tooltip>
              </el-tag>
              <el-tag type="info" v-else>终审待审核</el-tag>
            </div>
            <div v-if="basicInfo.exemptWriteType !== '0' && basicInfo.exemptWriteLastStatus === '1'">
              <el-tag type="success" v-if="basicInfo.exemptWriteQualityStatus === '1'">资格审查通过</el-tag>
              <el-tag type="danger" v-else-if="basicInfo.exemptWriteQualityStatus == '0'">资格审查不通过
                <el-tooltip :content="basicInfo.exemptNoPassReason" placement="right"><i class="el-icon-info"></i></el-tooltip>
              </el-tag>
              <el-tag type="info" v-else>资格审查待审核</el-tag>
            </div>
          </div>
          <div class="apply-content">
            <div class="apply-reason">
              <el-radio-group v-model="basicInfo.exemptWriteType" :disabled="!isCanUpdateExempt || !isEdit" @change="changeExemptWriteType">
                <el-radio v-for="(type, index) in exemptWriteTypeList" :key="index" :label="type.code">{{ type.name }}</el-radio>
              </el-radio-group>
            </div>
            <div v-if="basicInfo.exemptWriteType !== '0'" class="exempt-file">
              <multi-upload v-model="exemptWriteImageList" :title="exemptWriteFilePathTitle" :limit="-1" :disabled="!isCanUpdateExempt || !isEdit"></multi-upload>
              <multi-upload v-model="exemptWrite1ImageList" :title="exemptWriteFileOnePathTitle" :limit="-1" :disabled="!isCanUpdateExempt || !isEdit" v-if="basicInfo.exemptWriteType !== '4'"></multi-upload>
              <multi-upload v-model="exemptWrite2ImageList" :title="exemptWriteFileTwoPathTitle" :limit="-1" :disabled="!isCanUpdateExempt || !isEdit" v-if="basicInfo.exemptWriteType === '1'" upload-type="pdf"></multi-upload>
            </div>
            <div v-if="basicInfo.exemptWriteType !== '0' && !isEdit && isCanUpdateExempt && !isView" class="exempt-write-verify">
              <div class="exempt-write-verify-result">
                <div class="title">免笔试申请初审:</div>
                <el-button type="success" @click="exemptWriteVerify('1')">通过</el-button>
                <el-button type="danger" @click="exemptWriteVerify('0')">不通过</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="upload">
          <div class="blue-title">上传材料</div>
          <div class="upload-content">
            <multi-upload v-model="basicInfo.cardPhotoPaths" title="身份证正反面" tips="(顺序：肖像面，国徽面)" :limit="2" :disabled="!isEdit"></multi-upload>
            <multi-upload v-model="basicInfo.degreePhotoPaths" title="学历证书" :limit="-1" :disabled="!isEdit"></multi-upload>
            <single-upload v-model="basicInfo.userPhotoPath" title="个人照片" :disabled="!isEdit"></single-upload>
            <multi-upload v-model="basicInfo.recommendLetterPaths" title="推荐信" :limit="2" v-if="basicInfo.studentType === 'EMBA'" upload-type="document" :disabled="!isEdit"></multi-upload>
          </div>
        </div>
      </template>
      <div v-if="verifyResult === '1' && !isEdit && loaded" class="verify">
        <img src="../../../../../../assets/icons/already_pass.png" alt="">
      </div>
      <div v-if="verifyResult === '0' && !isEdit && loaded" class="verify">
        <img src="../../../../../../assets/icons/not_pass.png" alt="">
      </div>
    </div>
    <div v-if="isCanVerify && !isView" class="verify-btn">
      <el-button type="primary" @click="enrollModify('1')">审核通过</el-button>
      <el-button @click="enrollModify('0')">审核不通过</el-button>
    </div>
  </div>
</template>

<script>
import {
  provinceAndCityData,
  provinceCityAreaData,
  CodeToText,
  TextToCode,
  cloneDeep
} from '../../../../../../util/address/app.js'
import multiUpload from './multiUpload.vue'
import singleUpload from './singleUpload.vue'

export default {
  name: 'qualificationReview',
  data () {
    return {
      provinceAndCityData,
      provinceCityAreaData,
      loading: false,
      loaded: false,
      loadingText: '加载中，请稍等...',
      labelStyle: {
        textAlign: 'center',
        backgroundColor: '#fff',
        border: '1px solid #111111',
        color: '#3E4D41',
        fontSize: '13px'
      },
      contentStyle: {
        textAlign: 'center',
        backgroundColor: '#fff',
        border: '1px solid #111111',
        color: '#3E4D41',
        fontSize: '12px'
      },
      enrollBasicInfo: {},
      isEdit: false,
      basicInfo: {
        studentType: '',
        trueName: '',
        gender: '1',
        birthday: '',
        origin: [],
        joinWorkDate: '',
        workUnit: '',
        mobilePhone: '',
        email: '',
        emergencyContactName: '',
        emergencyContactPhone: '',
        address: '',
        experienceList: [{
          startDate: '',
          endDate: '',
          workUnit: '',
          workDuty: '',
          isLockEndDate: false
        }],
        honorList: [],
        cardPhotoPaths: [],
        degreePhotoPaths: [],
        userPhotoPath: '',
        recommendLetterPaths: [],
        exemptWriteType: '',
        exemptWriteFilePath: '',
        exemptWriteFilePath1: '',
        addressRegionCode: '',
        addressRegionName: '',
        addressRegionCodeArray: [],
        exemptWriteFilePath2: '',
        polity: '',
        industry: '',
        intendCity: '',
        jobTitle: '',
        jobLevel: '',
        degree: '',
        folk: '',
        workUnitType: '',
        jobDuty: '',
        exemptWriteFirstStatus: ''
      },
      originBasicInfo: {},
      exemptWriteImageList: [],
      exemptWrite1ImageList: [],
      exemptWrite2ImageList: [],
      // 是否可以核验
      isCanVerify: false,
      // 是否可以更新报考学校
      isCanUpdateSite: false,
      // 是否可以更新免笔试条件
      isCanUpdateExempt: false,
      admissionYear: '',
      selectExperience: [],
      selectHonor: [],
      genderList: [],
      folkList: [],
      polityList: [],
      workUnitTypeList: [],
      industryList: [],
      jobTitleList: [],
      jobLevelList: [],
      degreeList: [],
      exemptWriteTypeList: [],
      siteList: [],
      intendCityList: [],
      cardTypeList: []
    }
  },
  components: {
    multiUpload,
    singleUpload
  },
  props: {
    studentId: {
      type: String,
      default: ''
    },
    isView: {
      type: Boolean,
      default: false
    },
    verifyResult: {
      type: Boolean | String,
      default: false
    },
    passCardVerify: {
      type: Boolean | String,
      default: false
    }
  },
  methods: {
    changeLockEndTime (item) {
      if (item && item.isLockEndDate) {
        item.endDate = ''
      }
    },
    enrollDetail (code) {
      this.loadingText = '加载中，请稍等...'
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/enrollVerify/enrollDetail',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            this.admissionYear = response.data.admissionYear
            if (!response.data.enrollBasicInfo.originProvinceCode && !response.data.enrollBasicInfo.originCityCode) {
              const originProvinceName = response.data.enrollBasicInfo.originProvinceName
              const originCityName = response.data.enrollBasicInfo.originCityName
              if (originProvinceName && originCityName) {
                response.data.enrollBasicInfo.origin = [TextToCode[originProvinceName].code, TextToCode[originProvinceName][originCityName].code]
              } else {
                response.data.enrollBasicInfo.origin = []
              }
            } else {
              response.data.enrollBasicInfo.origin = [response.data.enrollBasicInfo.originProvinceCode, response.data.enrollBasicInfo.originCityCode]
            }
            if (!response.data.enrollBasicInfo.regionProvinceCode && !response.data.enrollBasicInfo.regionCityCode) {
              const regionProvinceName = response.data.enrollBasicInfo.regionProvinceName
              const regionCityName = response.data.enrollBasicInfo.regionCityName
              if (regionProvinceName && regionCityName) {
                response.data.enrollBasicInfo.fromRegion = [TextToCode[regionProvinceName].code, TextToCode[regionProvinceName][regionCityName].code]
              } else {
                response.data.enrollBasicInfo.fromRegion = []
              }
            } else {
              response.data.enrollBasicInfo.fromRegion = [response.data.enrollBasicInfo.regionProvinceCode, response.data.enrollBasicInfo.regionCityCode]
            }
            if (response.data.enrollBasicInfo && response.data.enrollBasicInfo.addressRegionCode) {
              response.data.enrollBasicInfo.addressRegionCodeArray = response.data.enrollBasicInfo.addressRegionCode.split(',') || []
            }
            this.basicInfo = response.data.enrollBasicInfo
            this.originBasicInfo = JSON.parse(JSON.stringify(response.data.enrollBasicInfo))
            this.isCanVerify = response.data.isCanVerify
            this.isCanUpdateSite = response.data.isCanUpdateSite
            this.isCanUpdateExempt = response.data.isCanUpdateExempt
            if (this.basicInfo.exemptWriteFilePath && this.basicInfo.exemptWriteFilePath.length > 0) {
              this.exemptWriteImageList = this.basicInfo.exemptWriteFilePath.split(',')
            }
            if (this.basicInfo.exemptWriteFilePath1 && this.basicInfo.exemptWriteFilePath1.length > 0) {
              this.exemptWrite1ImageList = this.basicInfo.exemptWriteFilePath1.split(',')
            }
            if (this.basicInfo.exemptWriteFilePath2 && this.basicInfo.exemptWriteFilePath2.length > 0) {
              this.exemptWrite2ImageList = this.basicInfo.exemptWriteFilePath2.split(',')
            }
            this.genderList = response.data.genderList
            this.folkList = response.data.folkList
            this.polityList = response.data.polityList
            this.workUnitTypeList = response.data.workUnitTypeList
            this.industryList = response.data.industryList
            this.jobTitleList = response.data.jobTitleList
            this.jobLevelList = response.data.jobLevelList
            this.degreeList = response.data.degreeList
            this.exemptWriteTypeList = response.data.exemptWriteTypeList
            this.siteList = response.data.siteList
            this.intendCityList = response.data.intendCityList || []
            this.cardTypeList = response.data.cardTypeList
            if (typeof code === 'string') {
              this.$emit('qualification-pass', code)
            }
          }
        }
      }).finally(() => {
        this.loading = false
        this.loaded = true
      })
    },
    editOrSave () {
      if (!this.isEdit) {
        this.isEdit = true
      } else {
        const mobilePhoneReg = /[1][0-9]{10}/
        // eslint-disable-next-line no-useless-escape
        const emailReg = /[a-z0-9]+([._\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+/
        if (!this.basicInfo.trueName) {
          this.$message.error('姓名不能为空')
          return
        } else if (!this.basicInfo.birthday) {
          this.$message.error('出生日期不能为空')
        } else if (!this.basicInfo.origin[0]) {
          this.$message.error('籍贯不能为空')
          return
        } else if (!this.basicInfo.origin[1]) {
          this.$message.error('籍贯不能为空')
          return
        } else if (!this.basicInfo.folk) {
          this.$message.error('民族不能为空')
          return
        } else if (!this.basicInfo.polity) {
          this.$message.error('政治面貌不能为空')
          return
        } else if (!this.basicInfo.workUnit) {
          this.$message.error('工作单位不能为空')
          return
        } else if (!this.basicInfo.workUnitType) {
          this.$message.error('单位性质不能为空')
          return
        } else if (!this.basicInfo.jobLevel) {
          this.$message.error('职级不能为空')
          return
        } else if (!this.basicInfo.industry) {
          this.$message.error('所属行业不能为空')
          return
        // } else if (!this.basicInfo.intendCity) {
        //   this.$message.error('意向城市不能为空')
        //   return
        } else if (!this.basicInfo.mobilePhone) {
          this.$message.error('手机不能为空')
          return
        } else if (!mobilePhoneReg.test(this.basicInfo.mobilePhone)) {
          this.$message.error('手机格式不正确')
          return
        } else if (!this.basicInfo.email) {
          this.$message.error('电子邮箱不能为空')
          return
        } else if (!emailReg.test(this.basicInfo.email)) {
          this.$message.error('电子邮箱格式不正确')
          return
        } else if (!this.basicInfo.emergencyContactName) {
          this.$message.error('紧急联系人不能为空')
          return
        } else if (!this.basicInfo.emergencyContactPhone) {
          this.$message.error('紧急联系方式不能为空')
          return
        } else if (!this.basicInfo.addressRegionCode) {
          this.$message.error('通信地址不能为空')
          return
        } else if (!this.basicInfo.address) {
          this.$message.error('详细通信地址不能为空')
          return
        } else if (!this.basicInfo.jobDuty) {
          this.$message.error('请填写职务')
          return
        } else if (!this.basicInfo.jobTitle) {
          this.$message.error('请填写职称')
          return
        } else if (!this.basicInfo.graduateSchool) {
          this.$message.error('请填写毕业学校')
          return
        } else if (!this.basicInfo.graduateMajor) {
          this.$message.error('请填写毕业专业')
          return
        } else if (!this.basicInfo.graduateDate) {
          this.$message.error('请填写毕业时间')
          return
        } else if (!this.basicInfo.siteId) {
          this.$message.error('报考学校不能为空')
          return
        }
        for (let i = 0; i < this.basicInfo.experienceList.length; i++) {
          for (let key in this.basicInfo.experienceList[i]) {
            if (!this.basicInfo.experienceList[i][key] && key !== 'isLockEndDate') {
              if ((key === 'endDate' && !this.basicInfo.experienceList[i].isLockEndDate) || (key !== 'endDate' && key !== 'isLockEndDate')) {
                this.$message.error('请完善学习与工作经历')
                return
              } else if (this.basicInfo.experienceList[i].isLockEndDate) {
                this.basicInfo.experienceList[i].endDate = ''
              }
            }
          }
        }
        let experienceList = cloneDeep(this.basicInfo.experienceList)
        if (experienceList && experienceList.length) {
          experienceList.map((item) => {
            if (item && item.isLockEndDate) {
              item.endDate = '至今'
            }
          })
        }
        for (let i = 0; i < this.basicInfo.honorList.length; i++) {
          let honor = this.basicInfo.honorList[i]
          if (!honor.honorName || !honor.honorUnitName || !honor.honorDate) {
            this.$message.error('请完善荣誉或论著')
            return
          }
        }
        this.basicInfo.exemptWriteFilePath = this.exemptWriteImageList && this.exemptWriteImageList.length ? this.exemptWriteImageList.join(',') : ''
        this.basicInfo.exemptWriteFilePath1 = this.exemptWrite1ImageList && this.exemptWrite1ImageList.length ? this.exemptWrite1ImageList.join(',') : ''
        this.basicInfo.exemptWriteFilePath2 = this.exemptWrite2ImageList && this.exemptWrite2ImageList.length ? this.exemptWrite2ImageList.join(',') : ''
        if (!this.basicInfo.exemptWriteType) {
          this.$message.error('申请免入学笔试理由不能为空')
          return
        } else if (!this.basicInfo.exemptWriteFilePath && this.basicInfo.exemptWriteType !== '0') {
          this.$message.error('免试材料不能为空')
          return
        } else if (!this.basicInfo.exemptWriteFilePath1 && this.basicInfo.exemptWriteType !== '0' && this.basicInfo.exemptWriteType !== '4') {
          this.$message.error('免考材料缺失')
          return
        } else if (!this.basicInfo.exemptWriteFilePath2 && this.basicInfo.exemptWriteType === '1') {
          this.$message.error('免考材料缺失')
          return
        } else if (!this.basicInfo.cardPhotoPaths[0] || !this.basicInfo.cardPhotoPaths[1]) {
          this.$message.error('请上传身份证正反面')
          return
        } else if (!this.basicInfo.degreePhotoPaths[0]) {
          this.$message.error('学历证书不能为空')
          return
        } else if (!this.basicInfo.userPhotoPath) {
          this.$message.error('个人照片不能为空')
          return
        } else if (this.basicInfo.studentType === 'EMBA' && !this.basicInfo.recommendLetterPaths[0] && !this.basicInfo.recommendLetterPaths[1]) {
          this.$message.error('请上传两封推荐信')
          return
        }
        const params = {
          studentType: this.basicInfo.studentType,
          trueName: this.basicInfo.trueName,
          gender: this.basicInfo.gender,
          birthday: this.basicInfo.birthday,
          originProvinceCode: this.basicInfo.origin[0],
          originProvinceName: this.basicInfo.originProvinceName,
          originCityCode: this.basicInfo.origin[1],
          originCityName: this.basicInfo.originCityName,
          regionProvinceCode: this.basicInfo.fromRegion[0],
          regionProvinceName: this.basicInfo.regionProvinceName,
          regionCityCode: this.basicInfo.fromRegion[1],
          regionCityName: this.basicInfo.regionCityName,
          joinWorkDate: this.basicInfo.joinWorkDate,
          address: this.basicInfo.address,
          workUnit: this.basicInfo.workUnit,
          mobilePhone: this.basicInfo.mobilePhone,
          email: this.basicInfo.email,
          emergencyContactName: this.basicInfo.emergencyContactName,
          emergencyContactPhone: this.basicInfo.emergencyContactPhone,
          cardPhotoPaths: this.basicInfo.cardPhotoPaths,
          degreePhotoPaths: this.basicInfo.degreePhotoPaths,
          // intendCity: this.basicInfo.intendCity,
          userPhotoPath: this.basicInfo.userPhotoPath,
          recommendLetterPaths: this.basicInfo.recommendLetterPaths,
          exemptWriteType: this.basicInfo.exemptWriteType,
          addressRegionCode: this.basicInfo.addressRegionCode,
          addressRegionName: this.basicInfo.addressRegionName,
          exemptWriteFilePath: this.basicInfo.exemptWriteFilePath,
          exemptWriteFilePath1: this.basicInfo.exemptWriteFilePath1,
          exemptWriteFilePath2: this.basicInfo.exemptWriteFilePath2,
          cardNo: this.basicInfo.cardNo,
          cardPhotoPath: this.basicInfo.cardPhotoPath,
          degreePhotoPath: this.basicInfo.degreePhotoPath,
          cardType: this.basicInfo.cardType,
          degree: this.basicInfo.degree,
          experiences: experienceList,
          honors: this.basicInfo.honorList,
          folk: this.basicInfo.folk,
          graduateDate: this.basicInfo.graduateDate,
          graduateMajor: this.basicInfo.graduateMajor,
          graduateSchool: this.basicInfo.graduateSchool,
          graduateNo: this.basicInfo.graduateNo,
          industry: this.basicInfo.industry,
          jobDuty: this.basicInfo.jobDuty,
          jobLevel: this.basicInfo.jobLevel,
          jobTitle: this.basicInfo.jobTitle,
          polity: this.basicInfo.polity,
          siteId: this.basicInfo.siteId,
          postCode: this.basicInfo.postCode,
          studentId: this.studentId,
          workUnitType: this.basicInfo.workUnitType
        }
        this.loadingText = '保存中，请稍等...'
        this.loading = true
        this.$ajax({
          url: '/workspace/manager/enrolling/student/enrollVerify/enrollModify',
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(params)
        }).then(response => {
          if (response.data) {
            if (response.data.responseCode === 'SUCCESS') {
              this.$message.success('保存成功')
              this.isEdit = false
              this.originBasicInfo = JSON.parse(JSON.stringify(this.basicInfo))
            } else {
              this.$message.error(response.data.message || '保存失败')
            }
          }
        }, () => {
          this.$message.error('保存失败')
        }).finally(() => {
          this.loading = false
        })
      }
    },
    enrollModify (code) {
      if (this.isEdit) {
        this.$message.error('请先保存')
        return
      }
      if (this.basicInfo.exemptWriteType !== '0' && !this.basicInfo.exemptWriteFirstStatus) {
        this.$message.error('请先完成免笔试申请审核')
        return
      }
      this.loading = true
      this.loadingText = '操作中，请稍等...'
      this.$ajax({
        url: '/workspace/manager/enrolling/student/enrollVerify',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId,
          verifyStatus: code
        })
      }).then(response => {
        if (response.data) {
          if (response.data.responseCode === 'SUCCESS') {
            this.$message.success('设置成功')
            this.$emit('qualification-pass', code)
            this.loading = false
          } else {
            this.$message.error(response.data.message || '设置失败')
            this.loading = false
          }
        }
      }, () => {
        this.loading = false
      })
    },
    CodeToText (code) {
      return CodeToText[code]
    },
    addExperience () {
      this.basicInfo.experienceList.push({
        startDate: '',
        endDate: '',
        workDuty: '',
        workUnit: ''
      })
    },
    dateToChinese (dateString) {
      // 将起始日期转换为中文，日期格式为：2020-01-01
      if (!dateString) {
        return ''
      } else if (dateString === '至今') {
        return dateString
      } else {
        dateString = dateString.replace(/-/g, '')
        return dateString.substring(0, 4) + '年' + dateString.substring(4, 6) + '月'
      }
    },
    handleSelectionChange (val) {
      this.selectExperience = val
    },
    deleteExperience () {
      if (this.selectExperience.length === 0) {
        this.$message.error('请选择要删除的行')
        return
      }
      if (this.selectExperience.length === this.basicInfo.experienceList.length) {
        this.$message.error('至少保留一行')
        return
      }
      this.selectExperience.forEach(item => {
        this.basicInfo.experienceList = this.basicInfo.experienceList.filter(ele => {
          return ele !== item
        })
      })
    },
    addHonor () {
      this.basicInfo.honorList.push({
        honorName: '',
        honorUnitName: '',
        honorDate: '',
        remark: ''
      })
    },
    deleteHonor () {
      this.selectHonor.forEach(item => {
        this.basicInfo.honorList = this.basicInfo.honorList.filter(ele => {
          return ele !== item
        })
      })
    },
    handleHonorSelectChange (val) {
      this.selectHonor = val
    },
    uploadFile (name, file) {
      this[name] = file
    },
    codeToName (code, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].code === code) {
          return list[i].name
        }
      }
    },
    idToName (id, list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          return list[i].name
        }
      }
    },
    upDateFormat (time) {
      if (time) {
        return time.substring(0, 4) + '-' + time.substring(4, 6) + '-' + time.substring(6, 8)
      } else {
        return ''
      }
    },
    changeOrigin (val) {
      this.basicInfo.originProvinceName = this.CodeToText(val[0])
      this.basicInfo.originCityName = this.CodeToText(val[1])
    },
    changeRegion (val) {
      this.basicInfo.regionProvinceName = this.CodeToText(val[0])
      this.basicInfo.regionCityName = this.CodeToText(val[1])
    },
    changeRegionArray (val) {
      let array = []
      if (val && val.length) {
        provinceCityAreaData.map((item) => {
          if (item && item.value && item.value === val[0]) {
            array.push({
              label: item.label,
              value: val[0]
            })
            if (item && item.children && item.children.length) {
              item.children.map((cityItem) => {
                if (cityItem && cityItem.value === val[1] && val[1]) {
                  array.push({
                    label: cityItem.label,
                    value: val[1]
                  })
                  if (cityItem.children && cityItem.children.length) {
                    cityItem.children.map((countyItem) => {
                      if (countyItem && countyItem.value === val[2] && val[2]) {
                        array.push({
                          label: countyItem.label,
                          value: val[2]
                        })
                      }
                    })
                  }
                }
              })
            }
          }
        })
      }
      if (array && array.length) {
        array.map((item, index) => {
          if (item && item.value) {
            if (index === 0) {
              this.basicInfo.addressRegionCode = item.value
              this.basicInfo.addressRegionName = item.label
            } else {
              this.basicInfo.addressRegionName = this.basicInfo.addressRegionName + ',' + item.label
              this.basicInfo.addressRegionCode = this.basicInfo.addressRegionCode + ',' + item.value
            }
          }
        })
      } else {
        this.basicInfo.addressRegionCode = ''
        this.basicInfo.addressRegionName = ''
      }
    },
    reset () {
      this.basicInfo = JSON.parse(JSON.stringify(this.originBasicInfo))
      if (this.basicInfo.exemptWriteFilePath && this.basicInfo.exemptWriteFilePath.length > 0) {
        this.exemptWriteImageList = this.basicInfo.exemptWriteFilePath.split(',')
      } else {
        this.exemptWriteImageList = []
      }
      if (this.basicInfo.exemptWriteFilePath1 && this.basicInfo.exemptWriteFilePath1.length > 0) {
        this.exemptWrite1ImageList = this.basicInfo.exemptWriteFilePath1.split(',')
      } else {
        this.exemptWrite1ImageList = []
      }
      if (this.basicInfo.exemptWriteFilePath2 && this.basicInfo.exemptWriteFilePath2.length > 0) {
        this.exemptWrite2ImageList = this.basicInfo.exemptWriteFilePath2.split(',')
      } else {
        this.exemptWrite2ImageList = []
      }
      this.isEdit = false
    },
    changeExemptWriteType (code) {
      this.exemptWriteImageList = []
      this.exemptWrite1ImageList = []
      this.exemptWrite2ImageList = []
    },
    exemptWriteVerify (code) {
      if (code === '1') {
        this.$confirm('确定初审通过此免笔试申请吗？', '操作提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => this.submitExemptWriteVerify(code, null))
      } else {
        this.$prompt('请输入不通过理由：', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: function (value) {
            if (!value) {
              return '请输入驳回理由'
            }
            return true
          }
        }).then(value => this.submitExemptWriteVerify(code, value.value))
          .catch(() => {
            this.$message({
              type: 'warning',
              message: '取消输入'
            })
          })
      }
    },
    submitExemptWriteVerify (code, noPassReason) {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/exemptWriteFirstVerify',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId,
          verifyStatus: code,
          noPassReason: noPassReason
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.basicInfo.exemptWriteFirstStatus = code
              this.basicInfo.exemptNoPassReason = noPassReason
              this.$message.success('提交成功')
              break
            }
            default: {
              this.$message.error(response.data['message'] || '提交失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    exemptWriteFilePathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '副高证书照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '2') {
        return '硕士毕业证书信息页照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '3') {
        return '国考准考证照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '4') {
        return '立功受奖证书信息页或专业技术职务资格证书照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteFileOnePathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '最后学历照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '2') {
        return '硕士学位证书信息页照片'
      } else if (this.basicInfo && this.basicInfo.exemptWriteType === '3') {
        return '国考成绩照片'
      } else {
        return '免考材料'
      }
    },
    exemptWriteFileTwoPathTitle () {
      if (this.basicInfo && this.basicInfo.exemptWriteType === '1') {
        return '单位证明'
      } else {
        return '免考材料'
      }
    }
  },
  created () {
    this.loaded = false
    this.enrollDetail()
  }
}
</script>

<style scoped lang="scss">
.qualification-review {
  .blue-title {
    color: #0D59A7;
    position: relative;
    font-weight: 550;
    padding-left: 10px;
    font-size: 13px;
    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 20px;
      background-color: #02A7F0;
      margin-right: 10px;
      position: absolute;
      left: 2px;
    }
  }
  & > .content {
    height: 422px;
    overflow: auto;
    padding: 15px 30px;
    position: relative;
    & > .verify {
      top: 44px;
      right: 25px;
      position: absolute;
      & > img {
        width: 123px;
        height: 115px;
        object-fit: contain;
      }
    }
    & > .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      & > .edit {
        display: flex;
        & > div {
          color: #027DB4;
          text-decoration: underline;
          font-size: 12px;
          padding-right: 20px;
          margin-right: 5px;
          & > span {
            cursor: pointer;
          }
        }
      }
      //& > .reset {
      //  cursor: pointer;
      //  color: #027DB4;
      //  text-decoration: underline;
      //  font-size: 12px;
      //}
    }
    & > .table {
      & > .table-title {
        font-size: 24px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
      }
      .el-form {
        .form-up {
          position: relative;
          .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 175px;
          }
          & > .right-img {
            position: absolute;
            width: 172px;
            height: 267px;
            border: 1px solid #000;
            border-left: none;
            //border-right: none;
            border-bottom: none;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            top: 0;
            right: 0;
            & > img {
              width: 90%;
              height: 90%;
              object-fit: contain;
            }
          }
          & > .edit {
            height: 331px;
          }
          .el-descriptions {
            flex: 1;
            letter-spacing: 0.1em;
          }
          ::v-deep  .higher {
            height: 60px !important;
          }
          .descriptions-content {
            text-align: center;
            color: #2213FF;
            font-weight: 550;
            .common {
              color: #3E4D41;
              font-weight: 500;
            }
            & > .graduation {
              color: #3E4D41;
              font-weight: 500;
              & > span {
                color: #2213FF;
                font-weight: 550;
                display: inline-block;
              }
              & > .graduation-date {
                width: 130px;
                text-align: left;
              }
              .grey {
                color: #3E4D41;
                font-weight: 500;
              }
              & > .school {
                width: 140px;
                margin-right: 7px;
              }
              & > .speciality {
                width: 130px;
              }
            }
          }
          .gender {
            .el-select {
              width: 80px;
            }
          }
          .name {
            max-width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .text-left {
            text-align: left !important;
          }
          ::v-deep  .el-descriptions__body {
            .empty {
              width: 116.55px;
              border: none !important;
            }
            .empty-content {
              width: 55px;
              border: none !important;
            }
            .none {
              border-right: none !important;
            }
            .none-content {
              border-left: none !important;
            }
          }
        }
        .form-down {
          display: flex;
          .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 268px !important;
          }
          & > .down-left {
            font-size: 13px;
            padding: 5px 0;
            width: 60px;
            writing-mode: vertical-rl;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #3E4D41;
            border-top: 1px solid #fff;
          }
          & > .table {
            flex: 1;
            ::v-deep  thead {
              font-size: 13px;
            }
            .el-table {
              border-bottom: 1px solid black;
              border-right: 1px solid black;
              margin: 0 auto;
            }
            .el-table th {
              border: 1px solid black !important;
              border-right: none !important;
              border-bottom: none !important;
              .cell {
                font-size: 13px !important;
              }
            }
            .el-table td {
              border: 1px solid black;
              border-right: none !important;
              border-bottom: none !important;
              .cell {
                font-size: 13px !important;
              }
            }
            .table-center {
              font-size: 12px;
              font-weight: 550;
              color: #2213FF;
              height: 60px;
              display: flex;
              align-items: center;
              justify-content: center;
              overflow: auto;
              .job-and-work-data-adjust{
                .el-date-editor.el-input, .el-date-editor.el-input__inner {
                  width: 129px !important;
                }
              }
            }
          }
        }
        & > .add-btn {
          padding: 10px 0px;
          display: flex;
          justify-content: center;
          border: 1px solid black;
          border-top: 1px solid #fff;
        }
      }
    }
    & > .apply {
      margin-top: 10px;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 10px;
      & > .apply-title {
        display: flex;
        align-items: center;
        gap: 20px;
      }
      & > .apply-content {
        padding-left: 30px;
        & > .apply-reason {
          display: flex;
          align-items: center;
          line-height: 0;
          & > .blue {
            margin-right: 25px;
            width: 150px;
            text-align: right;
            padding-right: 14px;
            color: #0D59A7;
            font-weight: 550;
          }
        }
        & > .exempt-write-verify {
          & > .exempt-write-verify-result {
            display: flex;
            align-items: center;
            gap: 30px;
            & > .title {
              color: #0D59A7;
              font-weight: 550;
            }
            & > .result {
              display: flex;
            }
          }
          & > .exempt-write-verify-button {
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    & > .upload {
      margin-top: 40px;
      & > .blue-title {
        margin-bottom: 15px;
      }
      & > .upload-content {
      }
    }
  }
  & > .more-high {
    height: 482px;
  }
  & > .verify-btn {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
